import { render, staticRenderFns } from "./KeyboardShortcutsModal.vue?vue&type=template&id=127bc28a&"
import script from "./KeyboardShortcutsModal.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports